import React from 'react';
import { Modal, Pagination, Select, Space } from 'antd';
import NoticeDocEditor from '../../../components/NoticeDocEditor';
import { loadState } from './state';

const NoticePreviewModal = ({
  open,
  onCancel,
  selectedDebtors,
  previewIndex,
  setPreviewIndex,
  debtorOptions,
  previewDebtor,
  previewValues,
}) => (
  <Modal
    title="催告内容预览"
    width={1200}
    open={open}
    onCancel={onCancel}
    footer={null}
    destroyOnClose
  >
    <div style={{ marginBottom: 12, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
      <Space wrap>
        <span style={{ color: '#666' }}>债务人：</span>
        <Pagination
          size="small"
          current={selectedDebtors.length ? (previewIndex + 1) : 1}
          total={selectedDebtors.length}
          pageSize={1}
          showSizeChanger={false}
          showQuickJumper={selectedDebtors.length > 20}
          onChange={(page) => {
            const idx = Math.max(0, Math.min(selectedDebtors.length - 1, Number(page || 1) - 1));
            setPreviewIndex(idx);
          }}
          disabled={selectedDebtors.length === 0}
        />
        <Select
          value={selectedDebtors.length ? previewIndex : undefined}
          style={{ width: 360 }}
          options={debtorOptions}
          placeholder="选择债务人"
          onChange={(idx) => setPreviewIndex(Number(idx || 0))}
          disabled={selectedDebtors.length === 0}
        />
      </Space>
      <span style={{ color: '#999' }}>
        {previewDebtor
          ? (previewDebtor.type === 'P'
            ? `${previewDebtor.name || '个人'} (${previewDebtor.idNo || '-'})`
            : `${previewDebtor.companyName || '企业'} (${previewDebtor.socialCreditCode || '-'})`)
          : ''}
      </span>
    </div>

    <NoticeDocEditor
      initialHtml={(loadState().contentHtml || '')}
      templateId={loadState().selectedTemplateId}
      values={previewValues}
      readOnly
      hideFillPanel
      hideReload
      hideAutoFill
      hideSave
      initialPageSettings={loadState().pageSettings}
    />
  </Modal>
);

export default NoticePreviewModal;

